import React, { useState, useRef, useMemo } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { useSelector, useDispatch } from 'react-redux';
import { hideEspDialog } from '../../redux/actions/dialogActions.js';
import {
  clearDate,
  setComment,
  setDate,
  setHour,
  setModule,
  setModType,
  setEsp,
  setCty,
  setLang,
  setStage,
  setTask,
  setWpl,
  clearTask,
  setVersion,
} from '../../redux/actions/logActions.js';
import {
  resetCountryButtons,
  resetStateAndOverlay,
  handleModuleTypeLogChange,
  showMsg,
  versions,
} from './utils/utils.js';
import ModuleTypesComponent from './utils/ModuleTypesComponent.js';
import SaveAndEditButtonComponent from './utils/SaveAndEditButtonsComponent.js';
import { dictionary } from '../../dictionary.js';
import DialogOverlay from './DialogOverlay.js';

const EspComponent = (props) => {
  const dispatch = useDispatch();
  const dialogProps = props.dialogProps;
  const toast = useRef(null);
  const dateLog = new Date(useSelector((state) => state.date.value));
  const espLog = useSelector((state) => state.esp.value);
  const ctyLog = useSelector((state) => state.cty.value);
  const langLog = useSelector((state) => state.lang.value);
  const moduleLog = useSelector((state) => state.module.value);
  const modTypeLog = useSelector((state) => state.modType.value);
  const stageLog = useSelector((state) => state.stage.value);
  const taskLog = useSelector((state) => state.task.value);
  const hourLog = useSelector((state) => state.hours.value);
  const wplLog = useSelector((state) => state.wpl.value);
  const commentLog = useSelector((state) => state.comment.value);
  const versionLog = useSelector((state) => state.version.value);
  const [index, setIndex] = useState(0);
  const [, setLockChecked] = useState(false);
  const [, setDevChecked] = useState(false);
  const isEspDialog = true;

  const extendedStages = useMemo(() => {
    const dbStages = dialogProps.eldData[0]?.stages_localization || [];

    return [{ name: 'Provide content' }, ...dbStages];
  }, [dialogProps.eldData]);

  return (
    <>
      <Dialog
        header={dictionary.esp_dialog_header}
        visible={dialogProps.isDialogOpen}
        style={{ width: '50vw' }}
        onHide={() => {
          dialogProps.setValuesOnInitialState();
          resetStateAndOverlay(setLockChecked, setDevChecked, dialogProps);
          dispatch(hideEspDialog());
        }}
      >
        <div className="field field-wrapper">
          <Toast ref={toast} />
          <label>{dictionary.dialog_label_date}</label>
          {dialogProps.showOverlay && <DialogOverlay dialogProps={dialogProps} />}
          <Calendar
            disabledDays={dialogProps.disabledDays}
            style={{ width: '100%' }}
            placeholder={dateLog}
            value={dateLog}
            onChange={(e) => {
              if (dialogProps.checkIfDayIsPlanned(e.value)) {
                dispatch(setDate(e.value));
                dialogProps.setShowOverlay(false);
              } else {
                showMsg(toast, dictionary);
                dispatch(clearDate());
              }
            }}
            showIcon
            dateFormat="dd/mm/yy"
          />
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_esp}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={espLog}
            options={
              dialogProps.eldData[0].length !== 0
                ? dialogProps.eldData[0].esp.sort((a, b) => a.name.localeCompare(b.name))
                : null
            }
            onChange={(e) => {
              dispatch(setEsp(e.value.name));
            }}
            optionLabel="name"
            placeholder={espLog !== null ? espLog : dictionary.dialog_placeholder_esp}
            className={espLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
          />
          {espLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_esp}</small>
          ) : null}
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_country}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={ctyLog}
            options={dialogProps.eldData[0].countries}
            filter
            filterInputAutoFocus
            onChange={(e) => {
              dispatch(setCty(e.value.name));
              setIndex(dialogProps.eldData[0].countries.indexOf(e.value));
            }}
            optionLabel="code"
            placeholder={ctyLog !== null ? ctyLog : dictionary.dialog_placeholder_country}
            className={ctyLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
          />
          {ctyLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_country}</small>
          ) : null}
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_lang}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={langLog}
            options={dialogProps.eldData[0].lang}
            filter
            filterInputAutoFocus
            onChange={(e) => {
              dispatch(setLang(e.value.name));
              setIndex(dialogProps.eldData[0].lang.indexOf(e.value));
            }}
            optionLabel="name"
            placeholder={langLog !== null ? langLog : dictionary.dialog_placeholder_lang}
            className={langLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
          />
          {langLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_lang}</small>
          ) : null}
        </div>
        <div className="field field-wrapper">
          <div className={modTypeLog === null && dialogProps.formSubmitted ? 'row row-invalid' : 'row'}>
            <ModuleTypesComponent
              resetCountryButtons={resetCountryButtons}
              dispatch={dispatch}
              setModType={setModType}
              clearTask={clearTask}
              setModule={setModule}
              isEspDialog={isEspDialog}
            />
          </div>
          {modTypeLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_module_types}</small>
          ) : null}
        </div>
        <div className="field field-wrapper">
          <label>{modTypeLog}:</label>
          <div className="field-dropdown-wrapper">
            <Dropdown
              style={{ width: '100%' }}
              value={moduleLog}
              filter
              filterInputAutoFocus
              options={
                dialogProps.eldData[0].length !== 0 ? handleModuleTypeLogChange(modTypeLog, dialogProps, index) : null
              }
              onChange={(e) => {
                dispatch(setModule(e.value.name));
              }}
              optionLabel="name"
              placeholder={moduleLog !== null ? moduleLog : dictionary.dialog_placeholder_module}
              className={moduleLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
            />
            {moduleLog === null && dialogProps.formSubmitted ? (
              <small className="p-error">{dictionary.dialog_error_module}</small>
            ) : null}
            {moduleLog === 'Drobne_projekty' ? (
              <>
                <Dropdown
                  style={{ width: '100%', marginTop: '0.5rem' }}
                  value={taskLog}
                  options={dialogProps.eldData[0].projects_countries.sort((a, b) => a.name.localeCompare(b.name))} //Drobne_projekty
                  filter
                  filterInputAutoFocus
                  onChange={(e) => {
                    dispatch(setTask(e.value.name));
                  }}
                  optionLabel="name"
                  placeholder={taskLog !== null ? taskLog : dictionary.dialog_placeholder_task}
                  className={taskLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
                />
                {taskLog === null && dialogProps.formSubmitted ? (
                  <small className="p-error">{dictionary.dialog_error_task}</small>
                ) : null}
              </>
            ) : null}
          </div>
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_version}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={versionLog !== null && versionLog !== undefined ? versions.find((v) => v.name === versionLog) : null}
            options={versions}
            onChange={(e) => {
              dispatch(setVersion(e.value.name));
            }}
            optionLabel="name"
            placeholder={versionLog !== null ? versionLog : dictionary.dialog_placeholder_version}
          />
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_stage}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={stageLog}
            options={extendedStages}
            filter
            filterInputAutoFocus
            onChange={(e) => {
              dispatch(setStage(e.value.name));
              if (e.value.name === 'Provide content') {
                dispatch(setHour(0));
              }
            }}
            optionLabel="name"
            placeholder={stageLog !== null ? stageLog : dictionary.dialog_placeholder_stage}
            className={stageLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
          />
          {stageLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_stage}</small>
          ) : null}
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_hours}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={hourLog}
            options={dialogProps.eldData[0].hours}
            filter
            filterInputAutoFocus
            disabled={stageLog === 'Provide content'}
            onChange={(e) => {
              dispatch(setHour(e.value.hour));
            }}
            optionLabel="hour"
            placeholder={
              hourLog !== null && hourLog !== undefined ? String(hourLog) : dictionary.dialog_placeholder_hours
            }
            className={(hourLog === null || hourLog === undefined) && dialogProps.formSubmitted ? 'p-invalid' : null}
          />
          {(hourLog === null || hourLog === undefined) && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_hours}</small>
          ) : null}
        </div>
        {dialogProps.postEditing ? (
          <div className="field field-wrapper">
            <label>{dictionary.dialog_label_wpl}</label>
            <Dropdown
              style={{ width: '100%' }}
              value={wplLog}
              options={dialogProps.wplArr}
              onChange={(e) => {
                dispatch(setWpl(e.value.name));
              }}
              optionLabel="name"
              placeholder={wplLog !== 0 ? wplLog : dictionary.dialog_placeholder_wpl}
              className={wplLog === 0 && dialogProps.formSubmitted ? 'p-invalid' : null}
            />
            {wplLog === 0 && dialogProps.formSubmitted ? (
              <small className="p-error">{dictionary.dialog_error_wpl}</small>
            ) : null}
          </div>
        ) : null}
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_comment}</label>
          <InputText
            style={{ width: '100%' }}
            value={commentLog !== null ? commentLog : ''}
            placeholder={dictionary.dialog_placeholder_comment}
            onChange={(e) => {
              dispatch(setComment(e.target.value));
            }}
            className={
              moduleLog === 'Drobne_projekty' && commentLog === null && dialogProps.formSubmitted ? 'p-invalid' : null
            }
          />
          {moduleLog === 'Drobne_projekty' && commentLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_comment}</small>
          ) : null}
        </div>
        <SaveAndEditButtonComponent
          espLog={espLog}
          ctyLog={ctyLog}
          langLog={langLog}
          versionLog={versionLog}
          modTypeLog={modTypeLog}
          moduleLog={moduleLog}
          stageLog={stageLog}
          hourLog={hourLog}
          taskLog={taskLog}
          commentLog={commentLog}
          isEspDialog={isEspDialog}
          setLockChecked={setLockChecked}
          setDevChecked={setDevChecked}
          dispatch={dispatch}
          resetStateAndOverlay={resetStateAndOverlay}
          resetCountryButtons={resetCountryButtons}
          postEditing={dialogProps.postEditing}
          setFormSubbmited={dialogProps.setFormSubbmited}
          onLogSave={dialogProps.onLogSave}
          onRowEditComplete={dialogProps.onRowEditComplete}
          dialogProps={dialogProps}
        />
      </Dialog>
    </>
  );
};

export default EspComponent;
